import React from "react";
import "../css/Footer.css";

function AminiiFooter() {
  const [subscribed, setSubscribed] = React.useState(false);
  const [emailInput, setEmailInput] = React.useState("");

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!emailInput.trim()) return;
    setSubscribed(true);
    setEmailInput("");
  };

  return (
    <footer className="amin-footer">
      <div className="amin-footer-container">
        {/* Col 1: Brand & Statement */}
        <div className="amin-footer-col amin-footer-brand-col">
          <h2 className="amin-footer-logo">A M I N I I</h2>
          <p className="amin-footer-tagline">
            Premium Modest Wear Inspired by Pakistani Elegance & Contemporary Luxury.
          </p>
          <p className="amin-footer-address">
            Address: Masjid Complex, Gandhi Bazar, Shimoga, Karnataka - 577202
          </p>
          <p className="amin-footer-owner">
            Owned By: <span className="amin-footer-owner-name">Abdul wahab (Samran)</span>
          </p>
          <p className="amin-footer-dev">
            Designed & Developed By{" "}
            <a
              href="https://faizzan-portfolio.netlify.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="amin-footer-credit-link"
            >
              Faizan Khan
            </a>{" "}
            {/* (<a href="mailto:itsfaizzan.khan@gmail.com" className="amin-footer-credit-email">itsfaizzan.khan@gmail.com</a>) */}
          </p>
        </div>

        {/* Col 2: Shop Links */}
        <div className="amin-footer-col">
          <h4 className="amin-footer-heading">SHOP</h4>
          <ul className="amin-footer-links">
            {/* <li><a href="/productList/girl/cotton-wear">Girl Collection</a></li>
            <li><a href="/productList/women/luxe-cordset">Luxe Co-ord Sets</a></li> */}            
            <li><a href="/productList">All Collections</a></li>
            {/* <li><a href="/productList">More</a></li> */}
            <li><a href="/productList">New Arrivals</a></li>
            <li><a href="/productList/women/premium-pakistani">Best of AMINII</a></li>
          </ul>
        </div>

        {/* Col 3: Customer Support & Policies */}
        <div className="amin-footer-col">
          <h4 className="amin-footer-heading">HELP & POLICIES</h4>
          <ul className="amin-footer-links">
            <li><a href="/about">About Us</a></li>
            <li><a href="/track">Track My Order</a></li>
            <li><a href="/contact-us">Contact Us</a></li>
            <li><a href="/shipping-policy">Shipping Policy</a></li>
            <li><a href="/return-policy">Exchange Policy (48 hrs)</a></li>
            <li><a href="/cancellation-policy">Cancellation Policy</a></li>
            <li><a href="/refund-policy">Refund Policy</a></li>
            <li><a href="/privacy-policy">Privacy Policy</a></li>
            <li><a href="/terms-of-service">Terms & Conditions</a></li>
          </ul>
        </div>

        {/* Col 4: Newsletter & Social */}
        <div className="amin-footer-col amin-footer-newsletter-col">
          <h4 className="amin-footer-heading">LET'S STAY IN TOUCH</h4>
          <p className="amin-footer-subtext">
            Be the first to know about new collection drops, exclusive offers & luxury launches.
          </p>
          {subscribed ? (
            <div style={{ color: "#d4af37", fontSize: "13px", fontWeight: "600", padding: "10px 0", lineHeight: "1.4" }}>
               Thank you for subscribing! You will receive our latest luxury collection drops.
            </div>
          ) : (
            <form className="amin-footer-newsletter-form" onSubmit={handleSubscribe}>
              <input
                type="email"
                placeholder="Enter your email address"
                className="amin-footer-input"
                value={emailInput}
                onChange={(e) => setEmailInput(e.target.value)}
                required
              />
              <button type="submit" className="amin-footer-submit-btn" aria-label="Subscribe">
                →
              </button>
            </form>
          )}

          <div className="amin-footer-social">
            <a
              href="https://www.instagram.com/aminii.clothing.in"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
              </svg>
            </a>
            <a
              href="https://www.youtube.com/@aminiiclothing"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
              </svg>
            </a>
            <a
              href="https://wa.me/919606132902"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>

      {/* Spanx-Style Giant Brand Watermark — edge-to-edge on all screens */}
      <div className="amin-footer-watermark-wrap">
        <div className="amin-footer-watermark" aria-hidden="true">
          {["A", "M", "I", "N", "I", "I"].map((letter, index) => (
            <span key={index}>{letter}</span>
          ))}
        </div>
      </div>

      {/* Footer Bottom Bar */}
      <div className="amin-footer-bottom">
        <p>© 2026 A M I N I I Clothing. All Rights Reserved.</p>
        <div className="amin-footer-bottom-links">
          <a href="/privacy-policy">Privacy</a>
          <span>|</span>
          <a href="/terms-of-service">Terms</a>
        </div>
      </div>
    </footer>
  );
}

export default AminiiFooter;
